import React, { useState, useEffect } from "react";
import HomeHeader from "../../../pages/HomePage/HomeHeader";
import axios from "axios";
import moment from "moment";
import { Helmet } from "react-helmet";
export const TermsAndConditions = () => {
  const language = localStorage?.getItem("language") || "english";
  const [publishedTerms, setPublishedTerms] = useState("");

  const getPublishedTermsAndConditions = async () => {
    await axios.get(`/api/content?type=terms&isPaginated=false`).then((res) => {
      let allTerms = res?.data?.data?.results;
      let publishTerms = allTerms?.filter((item) => item?.isActive)[0];
      setPublishedTerms({
        ...publishTerms,
        englishContent: (language === "english" && publishTerms?.englishContent) || "",
        arabicContent: (language === "arabic" && publishTerms?.arabicContent) || "",
      });
    });
  };
  useEffect(() => {
    getPublishedTermsAndConditions();
    //eslint-disable-next-line
  }, []);

  const getContent = () => {
    if (!publishedTerms) return "";
    return (language === "arabic" ? publishedTerms.arabicContent : publishedTerms.englishContent) === (undefined || "undefined")
      ? ""
      : language === "arabic"
      ? publishedTerms?.arabicContent
      : publishedTerms?.englishContent;
  };
  return (
    <div style={{ backgroundColor: "white", height: "100%" }}>
      <Helmet>
        <html lang={language === "arabic" ? "ar" : "en"} />

        <title>{language === "arabic" ? "الشروط والاحكام | فاتورتي" : "Terms & Conditions | Fatoraty"}</title>

        <meta name="description" content={language === "arabic" ? "الشروط والاحكام الخاصة بمنصة فاتورتي" : "Read Fatoraty terms and conditions."} />

        <meta property="og:title" content={language === "arabic" ? "الشروط والاحكام | فاتورتي" : "Terms & Conditions | Fatoraty"} />

        <meta
          property="og:description"
          content={language === "arabic" ? "الشروط والاحكام الخاصة بمنصة فاتورتي" : "Read Fatoraty terms and conditions."}
        />

        {/* <link rel="canonical" href={"https://staging.fatoraty.com/terms-and-conditions"} /> */}
        <link rel="canonical" href={"http://localhost:3000/terms-and-conditions"} />
      </Helmet>
      <HomeHeader />
      <div style={{ marginTop: "7rem", backgroundColor: "white" }}>
        {" "}
        <div className=" p-4">
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              direction: language === "arabic" ? "rtl" : "ltr",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            <div style={{ fontWeight: "400", fontSize: "18px", color: "#333333" }}>
              {language === "arabic" ? "الشروط والاحكام" : "Terms & Conditions"}
            </div>
            <p style={{ color: "#333333", fontSize: "13px", fontWeight: "400" }}>
              {" "}
              {language === "arabic" ? " آخر تحديث" : "Last Update"} {moment(publishedTerms?.updated_at)?.format("DD MMM YYYY")}{" "}
            </p>
            <div style={{ paddingTop: "2rem" }} className="terms-content" dangerouslySetInnerHTML={{ __html: getContent() }} />
          </div>
        </div>
      </div>
      {/* <HomeFooter /> */}
    </div>
  );
};
